import React, { useRef, useState, useEffect, useContext } from 'react'
import { 
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  OptionTabDiv,
  OptionImg,
  OptionTextDiv,
  OptionMainText,
  OptionSubText,
  CancelButton
} from './style'
import keyboard from '../../../assets/addStockModal/keyboard.svg'
import cross from '../../../assets/addStockModal/cross.svg'
import ModalContext from '../../../contexts/ModalContext'
import SectionContext from '../../../contexts/SectionContext'
import CertificatesContext from '../../../contexts/CertificatesContext'
import { useNavigate } from 'react-router-dom'

const AddStockMenu: React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const { setCertificatesSection } = useContext(SectionContext)
  const { setForWhom } = useContext(CertificatesContext)
  const navigate = useNavigate()

  const openCertificate = (who:string) => {
    setForWhom(who)
    setModalActive(false)
    setCertificatesSection('newCertificate')
    navigate('/panel/certificates/create')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Criar um novo certificado</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab'/>
        </CloseDiv>
      </HeaderDiv>
      <OptionTabDiv onClick={() => openCertificate('customer')}>
        <OptionImg src={keyboard} alt='Keyboard icon'/>
        <OptionTextDiv>
          <OptionMainText>Certificado para cliente</OptionMainText>
          <OptionSubText>Emita um novo certificado, que será encaminhado para o cliente.</OptionSubText>
        </OptionTextDiv>
      </OptionTabDiv>
      <OptionTabDiv onClick={() => openCertificate('supplier')}>
        <OptionImg src={keyboard} alt='Keyboard icon'/>
        <OptionTextDiv>
          <OptionMainText>Certificado de fornecedor</OptionMainText>
          <OptionSubText>Preencha os dados vindo do certificado de seu fornecedor, e atribua para um material.</OptionSubText>
        </OptionTextDiv>
      </OptionTabDiv>
      {/* <OptionTabDiv onClick={() => openCertificate('supplierWithPDF')}>
        <OptionImg src={keyboard} alt='Keyboard icon'/>
        <OptionTextDiv>
          <OptionMainText>Certificado com PDF</OptionMainText>
          <OptionSubText>Insira o PDF, do certificado de seu fornecedor, e preencha as informações de forma automática.</OptionSubText>
        </OptionTextDiv>
      </OptionTabDiv> */}
      <CancelButton onClick={() => setModalActive(false)}>Cancelar</CancelButton>
    </Container>
  )
}

export default AddStockMenu